import { render, staticRenderFns } from "./ReservationTagSelection.vue?vue&type=template&id=9fa8c42c"
import script from "./ReservationTagSelection.vue?vue&type=script&lang=js"
export * from "./ReservationTagSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports